import { DocumentReference } from "@firebase/firestore-types";
import { Businesses, Routes, Theme, Users } from "@just-in-types";
import { Dispatch } from "redux";
import { firestore } from "../../firebase";

export const enum ActionTypes {
  ADD_NEW_BUSINESS = "businesses.ADD_NEW_BUSINESS",
  ADD_NEW_SITE = "SITEes.ADD_NEW_BUSINESS",
  GET_BUSINESSES = "businesses.GET_BUSINESSES",
  GET_ARCHIVEBUSINESSES = "businesses.GET_ARCHIVEBUSINESSES",
  GET_BUSINESSES_SUBSCRIPTION = "businesses.GET_BUSINESSES_SUBSCRIPTION",
  GET_SITE_COUNTERS = "businesses.GET_SITE_COUNTERS",
  GET_SITE_COUNTERS_SUBSCRIPTION = "businesses.GET_SITE_COUNTERS_SUBSCRIPTION",
  GET_SITE = "businesses.GET_SITE",
  GET_SITE_SUBSCRIPTION = "businesses.GET_SITE_SUBSCRIPTION",
  SET_REFS_OBJECT = "businesses.SET_REFS_OBJECT",
  UPDATE_SITE_OPTIONS = "businesses.UPDATE_SITE_OPTIONS",
  UPDATE_SITE_ROUTES = "businesses.UPDATE_SITE_ROUTES",
}

export type BusinessesAction =
  | { payload: Businesses.Business; type: ActionTypes.ADD_NEW_BUSINESS }
  | { payload: Businesses.Site; type: ActionTypes.ADD_NEW_SITE }
  | { payload: Businesses.Business[]; type: ActionTypes.GET_BUSINESSES }
  | { payload: Businesses.Business[]; type: ActionTypes.GET_ARCHIVEBUSINESSES }
  | { payload: Businesses.Site; type: ActionTypes.GET_SITE }
  | {
      payload: {
        businessId: string;
        siteId: string;
        routes: Routes.RoutesObject;
      };
      type: ActionTypes.UPDATE_SITE_ROUTES;
    }
  | {
      payload: (() => void);
      type:
        | ActionTypes.GET_BUSINESSES_SUBSCRIPTION
        | ActionTypes.GET_SITE_SUBSCRIPTION;
    }
  | { payload: IBusinessRefsObject; type: ActionTypes.SET_REFS_OBJECT };

const getBusinessSites = async (business: Businesses.Business) => {
  const { businessId } = business;

  business.sites = [];

  try {
    const query = await firestore
      .collection(`businesses/${businessId}/sites`)
      .get();

    query.forEach((doc) => {
      const siteId = doc.id;
      const site = doc.data();

      business.sites.push({ siteId, ...site } as Businesses.Site);
    });

    return business;
  } catch (error) {
    console.error(error);

    return business;
  }
};

const sortBusinesses = (businesses: Businesses.Business[]) =>
  businesses.sort(
    ({ path: pathA }, { path: pathB }) =>
      pathA === pathB ? 0 : pathA > pathB ? 1 : -1
  );

export const getSiteData = async ({
  businessId,
  siteId,
}: {
  businessId: string;
  siteId: string;
}) => {
  try {
    const doc = await firestore
      .collection(`businesses/${businessId}/sites`)
      .doc(siteId)
      .get();
    const siteData = doc.data() as Businesses.Site;

    return siteData;
  } catch (error) {
    throw new Error(error);
  }
};

// 27_3_21 ***
export const updateShortcode = async ({
  businessId,
  shortcode,
}: {
  businessId: string;
  shortcode: string;
}) => {
  try {
    await firestore
      .collection(`businesses`)
      .doc(businessId)
      .update({ shortcode });
    return true;
  } catch (error) {
    console.error(error);

    return false;
  }
};

export const getBusinessData = async ({
  businessId,
}: {
  businessId: string;
}) => {
  try {
    const doc = await firestore
      .collection(`businesses`)
      .doc(businessId)
      .get();
    const businessData = doc.data() as Businesses.Business;

    return businessData;
  } catch (error) {
    throw new Error(error);
  }
};

export const getSiteSnapshot = ({
  businessId,
  siteId: siteIdArg,
}: {
  businessId: string;
  siteId: string;
}) => (dispatch: Dispatch<BusinessesAction>) => {
  const unsubscribe = firestore
    .collection(`businesses/${businessId}/sites`)
    .doc(siteIdArg)
    .onSnapshot(
      { includeMetadataChanges: true },
      (snapshot) => {
        const siteId = snapshot.id;
        const site = snapshot.data();

        dispatch({
          payload: { siteId, ...site } as Businesses.Site,
          type: ActionTypes.GET_SITE,
        });
      },
      (error) => {
        console.error(error);
      }
    );

  dispatch({
    payload: unsubscribe,
    type: ActionTypes.GET_SITE_SUBSCRIPTION,
  });
};

export const getBusinessesSnapshot = () => (
  dispatch: Dispatch<BusinessesAction>
) => {
  const unsubscribe = firestore.collection("businesses").onSnapshot(
    async (querySnapshot) => {
      const businessPromises: Array<Promise<Businesses.Business>> = [];

      querySnapshot.forEach((doc) => {
        const businessId = doc.id;
        const business = doc.data();

        

        if (business.isArchive !== 1) {
          businessPromises.push(
            getBusinessSites({ businessId, ...business } as Businesses.Business)
          );
        }
      });

      const businesses = await Promise.all(businessPromises);
      const sorted = sortBusinesses(businesses);

      

      dispatch({ payload: sorted, type: ActionTypes.GET_BUSINESSES });
    },
    (error) => {
      console.error(error);
    }
  );

  dispatch({
    payload: unsubscribe,
    type: ActionTypes.GET_BUSINESSES_SUBSCRIPTION,
  });
};

export const getArchiveBusinessesSnapshot = () => (
  dispatch: Dispatch<BusinessesAction>
) => {
  firestore.collection("businesses").onSnapshot(
    async (querySnapshot) => {
      const businessPromises: Array<Promise<Businesses.Business>> = [];

      querySnapshot.forEach((doc) => {
        const businessId = doc.id;
        const business = doc.data();

        

        if (business.isArchive === 1) {
          businessPromises.push(
            getBusinessSites({ businessId, ...business } as Businesses.Business)
          );
        }
      });

      const businesses = await Promise.all(businessPromises);

      const sorted = sortBusinesses(businesses);
      

      dispatch({ payload: sorted, type: ActionTypes.GET_ARCHIVEBUSINESSES });
    },
    (error) => {
      console.error(error);
    }
  );
};

export interface IRefsObject {
  path: string;
  ref: DocumentReference;
}
export interface IBusinessRefsObject extends IRefsObject {
  sites: {
    [id: string]: IRefsObject;
  };
}

const setBusinessPermissions = (
  businesses: Businesses.Business[],
  dispatch: Dispatch,
  permissions: Users.AccountData["permissions"]
) => {
  const businessRefs: { [id: string]: IBusinessRefsObject } = {};

  const setSiteRefsObject = (
    businessRef: DocumentReference,
    sites: Businesses.Site[]
  ) => {
    const siteRefs: { [id: string]: IRefsObject } = {};

    sites.forEach(({ siteId, path }) => {
      siteRefs[siteId] = {
        path,
        ref: businessRef.collection("sites").doc(siteId),
      };
    });

    return siteRefs;
  };

  businesses.forEach(({ businessId, path, sites }) => {
    const ref = firestore.collection("businesses").doc(businessId);

    if (permissions.businesses.some((id) => id === businessId)) {
      businessRefs[businessId] = {
        path,
        ref,
        sites: setSiteRefsObject(ref, sites),
      };
    }
  });

  dispatch({
    payload: businessRefs,
    type: ActionTypes.SET_REFS_OBJECT,
  });

  return businessRefs;
};

export const getBusinesses = (
  permissions: Users.AccountData["permissions"]
) => async (dispatch: Dispatch<BusinessesAction>) => {
  const query = await firestore.collection("businesses").get();
  const businessPromises: Array<Promise<Businesses.Business>> = [];

  query.forEach((doc) => {
    const businessId = doc.id;
    const business = doc.data();

    businessPromises.push(
      getBusinessSites({ businessId, ...business } as Businesses.Business)
    );
  });

  const businesses = await Promise.all(businessPromises);
  const sorted = sortBusinesses(businesses);

  setBusinessPermissions(businesses, dispatch, permissions);

  dispatch({ payload: sorted, type: ActionTypes.GET_BUSINESSES });
};

export type UpdateSiteOptions = (
  {
    businessId,
    siteId,
    siteOptions,
  }: {
    businessId: string;
    siteId: string;
    siteOptions: Businesses.SiteOptions;
  }
) => (dispatch: Dispatch) => Promise<boolean>;

export const updateSiteOptions = ({
  businessId,
  siteId,
  siteOptions,
}: {
  businessId: string;
  siteId: string;
  siteOptions: Businesses.SiteOptions;
}) => async (dispatch: Dispatch) =>
  firestore
    .collection(`businesses/${businessId}/sites`)
    .doc(siteId)
    .update({ ...siteOptions })
    .then(() => {
      dispatch({ type: ActionTypes.UPDATE_SITE_OPTIONS });

      return true;
    })
    .catch((error) => {
      console.error(error);

      return false;
    });

export const updateSiteRoute = ({
  businessId,
  routes,
  siteId,
}: {
  businessId: string;
  siteId: string;
  routes: Routes.RoutesObject;
}) => async (dispatch: Dispatch<BusinessesAction>) => {
  try {
    await firestore
      .collection(`businesses/${businessId}/sites`)
      .doc(siteId)
      .update({ routes });

    dispatch({
      payload: { businessId, routes, siteId },
      type: ActionTypes.UPDATE_SITE_ROUTES,
    });

    return true;
  } catch (error) {
    console.error(error);

    return false;
  }
};

export type GetBusinesses = () => (
  dispatch: Dispatch<BusinessesAction>
) => Promise<void>;
export type GetBusinessesSnapshot = () => (
  dispatch: Dispatch<BusinessesAction>
) => void;
export type GetArchiveBusinessesSnapshot = () => (
  dispatch: Dispatch<BusinessesAction>
) => void;
export type GetSiteSnapshot = (
  {
    businessId,
    siteId: siteIdArg,
  }: {
    businessId: string;
    siteId: string;
  }
) => (dispatch: Dispatch<BusinessesAction>) => void;
export type UpdateSiteRoute = (
  {
    businessId,
    routes,
    siteId,
  }: {
    businessId: string;
    siteId: string;
    routes: Routes.RoutesObject;
  }
) => (dispatch: Dispatch<BusinessesAction>) => Promise<boolean>;

export const addNewBusiness = ({
  businessName,
  guid,
  keyword,
  path,
  shortcode,
  theme,
}: {
  businessName: string;
  guid: string;
  keyword: string;
  path: string;
  shortcode: string;
  theme: Theme.Props;
}) => async (dispatch: Dispatch<BusinessesAction>) => {
  try {
    const businessRef = firestore.collection("businesses").doc();
    const business: Businesses.Business = {
      businessId: businessRef.id,
      businessName,
      guid,
      keyword,
      path,
      shortcode,
      sites: [],
      theme,
      yardName: businessName,
    };

    await businessRef.set(business);

    dispatch({ payload: business, type: ActionTypes.ADD_NEW_BUSINESS });
  } catch (error) {
    throw new Error(error);
  }
};

export type AddNewBusiness = (
  {
    businessName,
    guid,
    keyword,
    path,
    shortcode,
    theme,
  }: {
    businessName: string;
    guid: string;
    keyword: string;
    path: string;
    shortcode: string;
    theme: Theme.Props;
  }
) => (dispatch: Dispatch<BusinessesAction>) => Promise<void>;

export const addNewSite = ({
  businessId,
  site,
}: {
  businessId: string;
  site: Businesses.Site;
}) => async (dispatch: Dispatch<BusinessesAction>) => {
  try {
    await firestore
      .collection(`businesses/${businessId}/sites`)
      .doc(site.siteId)
      .set(site);

    dispatch({ payload: site, type: ActionTypes.ADD_NEW_SITE });

    return site;
  } catch (error) {
    throw new Error(error);
  }
};

export type AddNewSite = (
  {
    businessId,
    site,
  }: {
    businessId: string;
    site: Businesses.Site;
  }
) => (dispatch: Dispatch<BusinessesAction>) => Promise<Businesses.Site>;



// WEBPACK FOOTER //
// ./src/store/actions/businessesActions.ts